var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRespins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Frame 32"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0625,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FFE8E8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "block"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_302_2864",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 16,
    height: 17
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 4,
    y: 4.0625,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_302_2864)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "block_2",
    d: "M12 18.7298C11.0778 18.7298 10.2112 18.5548 9.40004 18.2048C8.58893 17.8548 7.88337 17.3798 7.28337 16.7798C6.68337 16.1798 6.20837 15.4743 5.85837 14.6632C5.50837 13.852 5.33337 12.9854 5.33337 12.0632C5.33337 11.1409 5.50837 10.2743 5.85837 9.46315C6.20837 8.65204 6.68337 7.94648 7.28337 7.34648C7.88337 6.74648 8.58893 6.27148 9.40004 5.92148C10.2112 5.57148 11.0778 5.39648 12 5.39648C12.9223 5.39648 13.7889 5.57148 14.6 5.92148C15.4112 6.27148 16.1167 6.74648 16.7167 7.34648C17.3167 7.94648 17.7917 8.65204 18.1417 9.46315C18.4917 10.2743 18.6667 11.1409 18.6667 12.0632C18.6667 12.9854 18.4917 13.852 18.1417 14.6632C17.7917 15.4743 17.3167 16.1798 16.7167 16.7798C16.1167 17.3798 15.4112 17.8548 14.6 18.2048C13.7889 18.5548 12.9223 18.7298 12 18.7298ZM12 17.3965C13.4889 17.3965 14.75 16.8798 15.7834 15.8465C16.8167 14.8132 17.3334 13.552 17.3334 12.0632C17.3334 11.4632 17.2362 10.8854 17.0417 10.3298C16.8473 9.77426 16.5667 9.26315 16.2 8.79648L8.73337 16.2632C9.20004 16.6298 9.71115 16.9104 10.2667 17.1048C10.8223 17.2993 11.4 17.3965 12 17.3965ZM7.80004 15.3298L15.2667 7.86315C14.8 7.49648 14.2889 7.21593 13.7334 7.02148C13.1778 6.82704 12.6 6.72982 12 6.72982C10.5112 6.72982 9.25004 7.24648 8.21671 8.27982C7.18337 9.31315 6.66671 10.5743 6.66671 12.0632C6.66671 12.6632 6.76393 13.2409 6.95837 13.7965C7.15282 14.352 7.43337 14.8632 7.80004 15.3298Z",
    fill: "#FF0000"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRespins);
export default __webpack_public_path__ + "static/media/respins.af73ded0d7cb1c45ac8ca9db17f02e75.svg";
export { ForwardRef as ReactComponent };